import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let { metadata } = data?.[0] ?? {}

    if (!metadata)
      return {
        account_id: null,
        doctor_id: null,
        originalValue: {
          account_id: null,
          doctor_id: null,
        },
      }

    let iTero = metadata.find(item => item.name === 'itero')

    return {
      account_id: iTero?.preferredAccountId,
      doctor_id: iTero?.preferredDoctorId,
      originalValue: {
        account_id: iTero?.preferredAccountId,
        doctor_id: iTero?.preferredDoctorId,
      },
    }
  }, [data])
}
